import React, { useEffect, useState } from 'react';

const DepositReportListPrint = () => {
    const [reports, setReports] = useState([]);
    const [filters, setFilters] = useState({});

    useEffect(() => {
        const stored = localStorage.getItem('print_deposit_reports_list');
        if (stored) {
            const parsed = JSON.parse(stored);
            setReports(parsed.reports || []);
            setFilters(parsed.filters || {});
        }

        setTimeout(() => window.print(), 900);
    }, []);

    const totalAmount = reports.reduce((acc, r) => acc + parseFloat(r.total_amount || 0), 0);
    const totalPayments = reports.reduce((acc, r) => acc + (r.payments_count || 0), 0);

    const formatDate = (d) => {
        if (!d) return '--';
        try { return new Date(d).toLocaleDateString('fr-MA'); } catch { return d; }
    };

    const fmt = (n) => Number(n).toLocaleString('fr-MA', { minimumFractionDigits: 2 });

    return (
        <div className="report-wrapper" dir="rtl">

            {/* ══ Header ══════════════════════════════════════════════════════ */}
            <div className="report-header">
                <div className="header-logo-side">
                    <img src="/logo.png" alt="شعار الجمعية" className="header-logo" />
                    <div>
                        <p className="assoc-name">جمعية تنمية النقل المدرسي</p>
                        <p className="assoc-sub">ولاد دحو</p>
                    </div>
                </div>
                <div className="header-title-side">
                    <h1 className="report-title">قائمة تقارير الإيداع البنكي</h1>
                    {filters.date_from && filters.date_to && (
                        <p className="report-period">
                            الفترة: من <strong>{formatDate(filters.date_from)}</strong> إلى <strong>{formatDate(filters.date_to)}</strong>
                        </p>
                    )}
                    <p className="report-print-date">تاريخ الطباعة: {new Date().toLocaleDateString('fr-MA')}</p>
                </div>
            </div>

            {/* ══ Main Table ══════════════════════════════════════════════════ */}
            <table className="main-table">
                <thead>
                    <tr>
                        <th className="col-num">#</th>
                        <th className="col-date">تاريخ الإيداع</th>
                        <th className="col-number">رقم التقرير</th>
                        <th className="col-mode">وسيلة الدفع</th>
                        <th className="col-status">الحالة</th>
                        <th className="col-amount">المبلغ الإجمالي</th>
                    </tr>
                </thead>
                <tbody>
                    {reports.length === 0 ? (
                        <tr><td colSpan="7" className="empty-row">لا توجد بيانات</td></tr>
                    ) : (
                        reports.map((r, idx) => (
                            <tr key={r.id} className={idx % 2 === 0 ? 'row-even' : 'row-odd'}>
                                <td className="td-center">{idx + 1}</td>
                                <td className="td-center">{formatDate(r.report_date)}</td>
                                <td className="td-center receipt-num">{r.report_number}</td>
                                <td className="td-center">{r.payment_mode || '--'}</td>
                                <td className="td-center">
                                    <span className={`td-status ${r.bank_transaction_id ? 'status-deposited' : 'status-pending'}`}>
                                        {r.bank_transaction_id ? 'تم الإيداع' : 'قيد الانتظار'}
                                    </span>
                                </td>
                                <td className="td-amount">{fmt(r.total_amount)} &nbsp;د.م</td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>

            {/* ══ Summary Table ═══════════════════════════════════════════════ */}
            <div className="summary-wrapper">
                <table className="summary-table">
                    <thead>
                        <tr>
                            <th colSpan="2" className="summary-header">ملخص التقارير</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="sum-label">عدد التقارير الإجمالي</td>
                            <td className="sum-val">{reports.length} تقرير</td>
                        </tr>
                        <tr className="sum-total-row">
                            <td className="sum-label">المجموع الكلي</td>
                            <td className="sum-val sum-grand">{fmt(totalAmount)} د.م</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* ══ Footer ══════════════════════════════════════════════════════ */}
            <div className="report-footer">
                <div className="footer-sign">
                    <span>توقيع أمين المال</span>
                    <div className="sign-line" />
                </div>
                <div className="footer-sign">
                    <span>ختم الجمعية</span>
                    <div className="sign-line" />
                </div>
            </div>

            {/* ══ Styles ══════════════════════════════════════════════════════ */}
            <style dangerouslySetInnerHTML={{ __html: `
                @import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700&display=swap');

                * { box-sizing: border-box; margin: 0; padding: 0; }

                body {
                    font-family: 'Cairo', sans-serif;
                    background: #fff;
                    color: #111;
                    direction: rtl;
                }

                .report-wrapper {
                    width: 210mm;
                    margin: 0 auto;
                    padding: 8mm 10mm;
                    direction: rtl;
                }

                /* ── Header ── */
                .report-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    border-bottom: 2px solid #000;
                    padding-bottom: 8px;
                    margin-bottom: 10px;
                }
                .header-logo-side { display: flex; align-items: center; gap: 10px; }
                .header-logo { height: 55px; }
                .assoc-name { font-size: 13px; font-weight: 700; }
                .assoc-sub  { font-size: 11px; color: #555; }
                .header-title-side { text-align: left; }
                .report-title { font-size: 18px; font-weight: 700; }
                .report-period { font-size: 11px; margin-top: 2px; }
                .report-print-date { font-size: 10px; color: #666; margin-top: 2px; }

                /* ── Main Table ── */
                .main-table {
                    width: 100%;
                    border-collapse: collapse;
                    font-size: 11px;
                    margin-bottom: 14px;
                }
                .main-table th {
                    background: #1e293b;
                    color: #fff;
                    padding: 6px 5px;
                    text-align: center;
                    border: 1px solid #000;
                    font-size: 11px;
                }
                .main-table td {
                    border: 1px solid #666;
                    padding: 4px 5px;
                    vertical-align: middle;
                }
                .row-even { background: #fff; }
                .row-odd  { background: #f8fafc; }

                .col-num      { width: 30px; }
                .col-date     { width: 100px; }
                .col-number   { width: 120px; }
                .col-mode     { width: 120px; }
                .col-status   { width: 120px; }
                .col-amount   { width: 130px; }

                .td-center  { text-align: center; }
                .td-amount  { text-align: center; font-weight: 700; }
                .receipt-num { font-weight: 700; font-family: monospace; }
                .td-status  { font-size: 10px; font-weight: 700; padding: 2px 6px; border-radius: 4px; }
                .status-deposited { color: #059669; }
                .status-pending   { color: #d97706; }
                .empty-row  { text-align: center; padding: 20px; color: #999; }

                /* ── Summary Table ── */
                .summary-wrapper {
                    display: flex;
                    justify-content: flex-end;
                    margin-bottom: 16px;
                }
                .summary-table {
                    width: 50%;
                    border-collapse: collapse;
                    font-size: 12px;
                }
                .summary-header {
                    background: #1e293b;
                    color: #fff;
                    text-align: center;
                    padding: 6px 10px;
                    border: 1px solid #000;
                    font-size: 12px;
                }
                .summary-table td {
                    border: 1px solid #888;
                    padding: 5px 10px;
                }
                .sum-label { text-align: right; font-weight: 600; background: #f1f5f9; width: 60%; }
                .sum-val   { text-align: center; font-weight: 700; }
                .sum-total-row td { background: #e2e8f0 !important; }
                .sum-grand { font-size: 14px; }

                /* ── Footer ── */
                .report-footer {
                    display: flex;
                    justify-content: space-around;
                    margin-top: 20px;
                    padding-top: 10px;
                    border-top: 1px solid #ccc;
                }
                .footer-sign { text-align: center; font-size: 12px; font-weight: 600; }
                .sign-line { border-top: 1px solid #000; width: 100px; margin: 30px auto 0; }

                /* ── Print ── */
                @media print {
                    @page { size: A4 portrait; margin: 8mm; }
                    body  { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                    .report-wrapper { width: 100%; padding: 0; }
                }
            `}} />
        </div>
    );
};

export default DepositReportListPrint;
